import { DialogConfig } from '@agent-ds/shared/components/dialog/dialog-config';
import { DialogRef } from '@agent-ds/shared/components/dialog/dialog-ref';
import {
  DialogService,
  StudentApiService,
} from '@agent-ds/shared/services';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { CounselingMemoUploadType as UploadType } from '@agent-ds/shared/enums';
import { StudentDetail } from '@agent-ds/shared/interfaces';
import { CounselingMemoConfirmDialogComponent } from '@agent-ds/student/components/counseling-memo-confirm-dialog/counseling-memo-confirm-dialog.component';
import { CounselingMemo } from '@agent-ds/shared/interfaces/memo';

@Component({
  selector: 'ag-counseling-memo-upload-dialog',
  templateUrl: './counseling-memo-upload-dialog.component.html',
  styleUrls: ['./counseling-memo-upload-dialog.component.scss'],
})
export class CounselingMemoUploadDialogComponent implements OnInit, OnDestroy {
  constructor(
    private dialogService: DialogService,
    private studentService: StudentApiService,
    public dialog: DialogRef,
    public config: DialogConfig<{ student: StudentDetail, memoRaw: string, selectedUploadType: UploadType }>,
  ) {}

  selectedUploadType: UploadType = UploadType.REGISTER;
  UploadType = UploadType;
  memoRaw: string = '';
  student: StudentDetail;

  ngOnInit() {
    this.student = this.config.data.student;
    this.memoRaw = this.config.data.memoRaw || '';
    this.selectedUploadType = this.config.data.selectedUploadType || UploadType.REGISTER;
  }

  ngOnDestroy() { }

  public close(): void {
    this.dialog.close();
  }

  public reflect(): void {
    const request: CounselingMemo = {
      memoRaw: this.memoRaw
    };

    // Open dialog for review only when memo was parsed successfully.
    this.studentService.parseCounselingMemo(request)
      .subscribe((parsedMemoResp) => {
        this.dialog.close();
        this.dialogService.open(CounselingMemoConfirmDialogComponent, {
          data: {
            student: this.student,
            uploadType: this.selectedUploadType,
            memoRaw: parsedMemoResp.memoRaw,
            memoParsed: parsedMemoResp.memoParsed
          }
        });
      });
  }
}
